<template>
  <tail-water-monitoring-chart v-if="isShowChart" :chartRequestParams="chartRequestParams" @back="isShowChart = false" />
  <div class="screen-wrapper" v-else>
    <div class="screen" id="screen">
      <div class="header">
        <div class="company-name">{{company.name}}</div>
        <div class="title">养殖尾水监测</div>
        <div class="weather">
          <iframe name="weather_inc" src="//i.tianqi.com/index.php?c=code&id=10&color=black" width="240" height="25" frameborder="0" marginwidth="0" marginheight="0" scrolling="no" ></iframe>
          <div>{{time}}</div>
          <div class="count-down" @click="refresh">
            <span>{{countDown}}</span>
            <i class="el-icon-refresh" ref="refresh"></i>
          </div>
        </div>
      </div>
      <div class="content" v-if="sensorEquipments.length !== 0">
        <div class="box">
          <equipment-group-header :data="sensorEquipments[0]"/>
          <div class="equipment-group">
            <template v-for="item in sensorEquipments[0].sensors">
              <equipment-info :data="item" :powerStatus="item.powerStatus" :fishBaseId="fishBaseId" :id="sensorEquipments[0].id" :key="item.id" @showChart="showChart" />
            </template>
          </div>
        </div>
        <div class="box">
          <equipment-group-header :data="sensorEquipments[1]"/>
          <div class="equipment-group">
            <template v-for="item in sensorEquipments[1].sensors">
              <equipment-info :data="item" :powerStatus="item.powerStatus" :fishBaseId="fishBaseId" :id="sensorEquipments[1].id" :key="item.id" @showChart="showChart" />
            </template>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import EquipmentGroupHeader from "./components/EquipmentGroupHeader.vue"
import EquipmentInfo from "./components/EquipmentInfo.vue"
import tailWaterMonitoringChart from "./tailWaterMonitoringChart.vue"
import { getEquipment, getEquipmentsData, getCompanyName } from "@/service/apiData.js"
import { Loading } from 'element-ui'

export default {
  name: 'tailWaterMonitoring',
  components: {
    'equipment-group-header': EquipmentGroupHeader,
    'equipment-info': EquipmentInfo,
    'tail-water-monitoring-chart': tailWaterMonitoringChart
  },
  data () {
    return {
      // 设备数据
      sensorEquipments: [],
      // 公司信息
      company: {},
      // 时间
      time: '',
      fishBaseId: '',
      // 倒计时
      countDown: 120,
      isShowChart: false,
      chartRequestParams: {},
    }
  },
  computed: {},
  methods: {
    handleScreenAuto () {
      return
      const designDraftWidth = 1920 // 设计稿的宽度
      const designDraftHeight = 936 // 设计稿的高度
      // 根据屏幕的变化适配的比例
      const scale =
        document.documentElement.clientWidth /
          document.documentElement.clientHeight <
        designDraftWidth / designDraftHeight
          ? document.documentElement.clientWidth / designDraftWidth
          : document.documentElement.clientHeight / designDraftHeight
      // 缩放比例
      document.querySelector('#screen').style.transform = `scale(${scale}) translate(-50%)`
    },
    // 获取设备数据
    async getEquipment () {
      await this.getCompanyName()
      // TODO: 水质监测/尾水监测 两个都显示的公司   设置固定基地id
      if(this.company.id == '636089367965017082'){
        this.fishBaseId = 516
        this.getEquipmentsData()
        return
      }
      const { data } = await getEquipment()
      this.fishBaseId = data[0].fishBaseId
      this.getEquipmentsData()
    },
    async getEquipmentsData (IsGetRealTimeData = false) {
      var loadinginstace = Loading.service({ fullscreen: true, background: '#00000000', text: '加载中' })

      const { data: equipmentGroupData } = await getEquipmentsData({FishBaseId: this.fishBaseId, IsGetRealTimeData})
      this.countDown = 120
      this.sensorEquipments = equipmentGroupData.sensorEquipments;

      loadinginstace.close()
    },
    // 获取公司信息
    async getCompanyName () {
      const { data } = await getCompanyName()
      this.company = data
    },
    formatterTime () {
      let time = this.$timeformat(new Date());
      time = time.split('-')
      time = `${time[0]}年${time[1]}月${time[2]}`
      time = time.split('  ')
      this.time = `${time[0]}日 ${time[1]}`
    },
    // 刷新
    refresh () {
      this.$refs.refresh.style.transform = `rotate(360deg)`;
      this.getEquipmentsData(true)
    },
    showChart(params){
      this.isShowChart = true;
      this.chartRequestParams = params
    }
  },
  mounted () {
    this.handleScreenAuto()
    window.onresize = () => this.handleScreenAuto()
    this.getEquipment()
    this.formatterTime()
    setInterval(() => {
      this.formatterTime()
    }, 1000);

    setInterval(() => {
      this.countDown--;
      if(this.countDown === 0){
       this.getEquipmentsData()
      }
    }, 1000);
  },
  deleted () {
    window.onresize = null
  }
}
</script>
<style scoped lang="stylus">
.screen-wrapper {
  width: 100%;
  height: 100%;
  background-image: url(./images/bg.png);
  background-size: 100% 100%;
  repeat: no-repeat;
  .screen {
    display: inline-block;
    // width: 1920px;
    width: 100%;
    // height: 936px;
    // transform-origin: 0 0;
    // position: absolute;
    // left: 50%;
    display: flex;
    flex-direction: column;
    .header{
      width: 100%;
      height: 64px;
      background: #C7DEFE;
      padding: 16px 24px;
      box-sizing: border-box;
      display: flex;
      justify-content: space-between;
      align-items: center;
      position: relative;
      .company-name{
        font-size: 24px;
        font-weight: 500;
        color: #001133;
      }
      .title{
        font-size: 28px;
        font-weight: 600;
        color: #001133;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
      }
      .weather{
        display: flex;
        align-items: center;
        .count-down{
          position: relative;
          margin-left: 15px;
          span{
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            cursor: pointer;
          }
          i{
            font-size: 50px;
            cursor: pointer;
            color: #FFF;
            transition: all 1s;
          }
        }
      }
    }
    .content{
      width: 100%;
      flex: 1;
      padding: 0 70px;
      box-sizing: border-box;
      display: flex;
      flex-direction: column;
      .box{
        width: 100%;
        flex: 1;
        margin: 15px 0;
        .equipment-group{
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-top: 10px;
        }
      }
    }
  }
}
</style>
